// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import "babel-polyfill";

import Vue from 'vue'
import App from './App'
import router from './router'
import VueQuillEditor from 'vue-quill-editor'
import VueCookie from 'vue-cookie'

Vue.use(VueCookie);

// require styles
import 'quill/dist/quill.core.css'

Vue.use(VueQuillEditor, {
        modules: {
          toolbar: [
            ['bold', 'italic'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['link']
          ]
        }
      });

import VueResource from 'vue-resource'
import Vuex from 'vuex'
import store from './store/store'
import { mapState, mapMutations, mapActions } from 'vuex'

Vue.config.productionTip = false;

// Vue.use(VueQuill);
Vue.use(Vuex);
Vue.use(VueResource);

Vue.http.interceptors.push(function(request, next) {
  // REF: https://stackoverflow.com/questions/39665244/vue-resource-interceptor-for-auth-headers
  // modify headers
  if (request.url === process.env.QB_ANSWER_URL && request.method === 'POST') {
    request.headers.set('Content-Type', 'application/json');
    request.headers.set('Accept', 'application/json');
  }
  else {
    request.headers.set('Content-Type', 'application/json');
    request.headers.set('Accept', 'application/json');
    request.headers.set('x-auth-token', this.userAuthToken);
  }

  next();
});

//FIXME: For Login Page, have an unauthorized params to display the unauthorize message or "You've successfully logged out message".
//FIXME: Uncomment when login API is live
router.beforeResolve((to, from, next) => {
  if (store.state.userAuthToken !== null && store.state.userId !== null && store.state.userEmail !== null) {
    window.scrollTo(0,0);
    next();
  }
  else if (Vue.cookie.get('userAuthToken') !== null && Vue.cookie.get('userId') !== null && Vue.cookie.get('userEmail') !== null){
    store.dispatch('updateUserProfile', {
        userAuthToken: Vue.cookie.get('userAuthToken'),
        userId: Vue.cookie.get('userId'),
        userEmail: Vue.cookie.get('userEmail'),
    });
    next();
  }
  //Note: This is to prevent infinite loop on Login page
  else if (to.name === 'Login') {
    next();
  }
  else {
    next({ name: 'Login'});
  }
});

Vue.mixin({
  computed: {
    ...mapState(['userAuthToken', 'userEmail']),
  },
  methods: {
    ...mapMutations(['unsetStore']),
    ...mapActions(['updateCoachingActionsLessonsAll','updateCoachingPlansAll','updatePatientsAllOverview']),

    //This is a helper function for the app to handle the various status errors
    handlingAPIerror: function(statuscode){
      if (statuscode === 401) {
        this.clearAllSessionData({ errorStatusCode: '401'});
      }
      if (statuscode === 403) {
        this.clearAllSessionData({ errorStatusCode: '403'});
      }
    },
    /* intended to be called in the action and lesson componnents:
    * previousPlanArray = previous, currentItem = currentAction/currentLesson, targetCoachPlans = clone of current store.coachingPlans and newItemId is for posts
    */

    updateProgramPlans: function(previousPlanArray, currentItem, targetCoachPlans, newItemId){

      let currentPlanArray = currentItem.data.options.belongsToTemplate;
      let currentItemId = currentItem.id !== null ? currentItem.id: newItemId ;

      let deletionList = previousPlanArray.filter((item) => {
        return currentPlanArray.indexOf(item) === -1
      });
      let additionList = currentPlanArray.filter((item) => {
        return previousPlanArray.indexOf(item) === -1
      });
      let constructCoachPlansObject = targetCoachPlans;

      deletionList.forEach((el)=>{
        //for each in deletion list. find in the childPlans of the coach and then remove it
        constructCoachPlansObject.forEach((plan)=> {
          if (plan.id === el) {
            let targetChildPlanIndex = plan.data.childPlans.indexOf(currentItemId);
            plan.data.childPlans.splice(targetChildPlanIndex, 1);
          }
        })
      });

      additionList.forEach((el)=>{
        //for each in addition list. find the coach id and push it in
        constructCoachPlansObject.forEach((plan)=> {
          if (plan.id === el) {
            plan.data.childPlans.push(currentItemId);
          }
        })
      });

      let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programPlanTemplate';

      for (let i = 0; i < constructCoachPlansObject.length; i++ ){
        this.$http.put(requestUrl, constructCoachPlansObject[i]).then((response) => {
          if (i === constructCoachPlansObject.length - 1) {
            this.getProgramPlans();
          }
        }, (error) => {
          if (i === constructCoachPlansObject.length - 1) {
            this.getProgramPlans();
          }
          Rollbar.error(`Failed to put program data from ${requestUrl}`, error);
        });
      }


    },
    getProgramPlans: function () {
      return new Promise((resolve, reject) => {
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programPlanTemplates?limit=10000';

        this.$http.get(requestUrl).then( (response) => {

          let actionPlans = response.body.result.filter((element) => element.planType === 'action' && element.attribute === 'NVSDemoCoaching');
          let lessonPlans = response.body.result.filter((element) => element.planType === 'lesson' && element.attribute === 'NVSDemoCoaching');

          this.updateCoachingPlansAll({
            coachingLessonPlansAll: lessonPlans,
            coachingActionPlansAll: actionPlans
          });
          resolve();
        }, (error)=> {
          Rollbar.error(`Failed to fetch program data from ${requestUrl}`, error);
          this.handlingAPIerror(error.status);
          reject();
        }) ;
      });

    },
    getProgramPatients: function () {
      return new Promise((resolve, reject) => {
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programUsers?limit=10000';

        let patientsAllOverview;

        this.$http.get(requestUrl).then((response) => {
          //program patient results is nested in result.result because there will be pagination info
          patientsAllOverview = response.body.result.result.filter((element) => {
            // this is filtering for patients with the profile type userPlans
            return typeof(element.userPlans.find((element) => element.planType === "profile")) !== 'undefined'
          });

          this.updatePatientsAllOverview({
            patientsAllOverview: patientsAllOverview
          });
          resolve();

        }, (error) => {
          Rollbar.error(`Failed to fetch patient data from ${requestUrl}`, error);
          this.handlingAPIerror(error.status);
          reject();
        });
      })
    },
    getProgramItems: function () {
      return new Promise((resolve, reject) => {
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programPlans?limit=10000';

        this.$http.get(requestUrl).then((response) => {

          // program items results is nested in result.result because there will be pagination info
          // exclude deleted items here
          let actionItems = response.body.result.result.filter((element) => element.planType === 'action' && element.attribute === 'NVSDemoCoaching' && element.data.deletedStatus === false);
          let lessonItems = response.body.result.result.filter((element) => element.planType === 'lesson' && element.attribute === 'NVSDemoCoaching' && element.data.deletedStatus === false);

          this.updateCoachingActionsLessonsAll({
            coachingLessonsAll: lessonItems,
            coachingActionsAll: actionItems
          });

          resolve();

          }, (error) => {
          Rollbar.error(`Failed to fetch program data from ${requestUrl}`, error);
          //FIXME: depending on the help status code, the clearallsessiondata should have different params passed into it
          this.handlingAPIerror(error.status);
          reject();
        });

      });
    },
    //TODO: this function should take in an additional param that should be passed to the Login page so that the login page would display the correct informational message for the user
    clearAllSessionData: function(params){
      this.$cookie.delete('userAuthToken');
      this.$cookie.delete('userId');
      this.$cookie.delete('userEmail');
      this.unsetStore();
      this.$router.push({ name: 'Login', params: params });
    },
    generateIconClass: function(text) {
      //FIXME: Dependent on the UI for the Backoffice. May need to add additional support for more icons
      if (!text) {
        return null
      }
      if (text === 'download') {
        return 'download icon';
      }
      else if (text === 'watch') {
        return 'play circle icon'
      }
      else if (text === 'email') {
        return 'envelope icon'
      }
      return null
    },
    backToRoute: function() {
      let temp = window.location.hash;
      let parentPage = window.location.hash.split('/');
      parentPage.splice(-1,1);
      parentPage.splice(0,1);
      return '/' + parentPage.join('/');
    },
    convertUTCtoLocalTime: function (UTCTimestamp) {
      let year = new Date(UTCTimestamp).getUTCFullYear();
      let month = new Date(UTCTimestamp).getUTCMonth();
      let date = new Date(UTCTimestamp).getUTCDate();

      return new Date(year, month, date); //return Local Date Object forced to 00:00
    },
    //This is for converting Local Timestamps into acceptable UTC format for backend
    convertLocaltoUTCTimeStamp: function (localTimestamp, setHour = false, setMinute = false) {
      let year = new Date(localTimestamp).getFullYear();
      let month = new Date(localTimestamp).getMonth();
      let date = new Date(localTimestamp).getDate();
      let hour = 0;
      let minute = 0;

      if (setHour === true){
        hour = new Date(localTimestamp).getHours();
      }
      if (setMinute === true){
        minute = new Date(localTimestamp).getMinutes()
      }

      return new Date(Date.UTC(year, month, date, hour, minute)).getTime(); //return UTC timestamp
    },
    localizedTimestamp: function (timestamp,
                                  userLocale = 'en-US',
                                  options = {
                                    timeZone: 'UTC', //defaults to UTC to account for travelling humans
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric'
                                  }) {
      var temp = new Date(parseInt(timestamp));
      return temp.toLocaleString(userLocale, {
        timeZone: options.timeZone,
        weekday: options.weekday ? options.weekday : undefined,
        year: options.year ? options.year : undefined,
        month: options.month ? options.month : undefined,
        day: options.day ? options.day : undefined,
        hour: options.hour ? options.hour : undefined,
        minute: options.minute ? options.minute : undefined,
      });
    },
    dynamicNestedSort: function (prop, arr) {
      let sortOrder = 1;
      if(prop[0] === "-") {
        sortOrder = -1;
        prop = prop.substr(1);
      }

      prop = prop.split('.');
      let len = prop.length;

      arr.sort( (a, b) => {
        let i = 0;
        while( i < len ) { a = a[prop[i]]; b = b[prop[i]]; i++; }
        if (a < b) {
          return (sortOrder * -1);
        } else if (a > b) {
          return sortOrder;
        } else {
          return 0;
        }
      });
      return arr;
    },
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js